import axios from 'axios'
let qs = require('querystring')
import helper from './helper'
import { interfaceFn, timeFn } from '@/assets/util.js';
import store from '@/vuex/store.js';
import { Message } from 'element-ui'
import router from '../router'

//console.log( process.env.NODE_ENV)
//判断环境提供baseURL，注意要与后台地址一致
let root = interfaceFn();
// 引用axios，设置头文件
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.restapi = 'true';

function apiAxios (method, url, params, token, obj) {
	let deviceId = window.localStorage.getItem('deviceId');
	// 门店编号 + (时间yyyyMMddHHmmss) + 三位随机数 如 10001-202108100808-111
	if (!deviceId) window.localStorage.setItem('deviceId', store.state.shopId + '' + timeFn(5) + '' + Math.floor(Math.random() * 1000 + 1));
	if (params) {
		params = helper.filterNull(params)
	}
	return axios({
		method: method,
		//拼接参数
		url: method === 'GET' ? helper.queryString(url, params) : url,
		data: obj ? qs.stringify(params) : params,
		baseURL: root,
		timeout: 10*60*1000,
		headers: {
//			Authorization: `Bearer ${token}`
			deviceId: deviceId
		},
		withCredentials: true
	}).then((res) => {
		if (res.status == 200) {} else {
			Message({
				message: res.data.message,
				type: 'warning',
				duration: 2000
			})
		}
		return res;
	}).catch((err) => {
    if (err.response) {
      let request = err.request;
      if (request.status == 500) {
        let msg = '服务器开小差啦~';
        if (err.request && err.request.response) {
          let response = JSON.parse(err.request.response);
          if (response && response.message) {
            msg = response.message;
          }
        }
        Message({
          message: msg,
          type: 'error',
          duration: 2000
        })
      } else if (request.status == 504) {
        Message.error('网络请求超时');
      } else if (request.status == 403) {
        // router.push({path: '/login'});
        // Message({
        //   message: '登录已过期',
        //   type: 'warning',
        //   duration: 2000
        // })

        // 拦截判断
        if (request.responseText.indexOf('机房安全管理') != -1 || request.responseText.indexOf('网站未备案') != -1) {
          apiAxios(method, url, params, token, obj);
        } else {
          store.state.loginExpired = true;
        }
      } else if (request.status == 404) {
        Message.error('接口不存在');
      } else {
        Message({
          message: (JSON.parse(request.response)).message || '服务器开小差啦~',
          type: 'error',
          duration: 2000
        })
      }
      return request;
    }
	})
}

// 返回在vue模板中的调用接口
export default {
	get: function (url, params, token) {
		return apiAxios('GET', url, params, token)
	},
	post: function (url, params, token) {
		return apiAxios('POST', url, params, token)
	},
	post2: function (url, params, token) {
		return apiAxios('POST', url, params, token, true)
	},
	put: function (url, params, token) {
		return apiAxios('PUT', url, params, token)
	},
	delete: function (url, params, token) {
		return apiAxios('DELETE', url, params, token)
	},
}



// WEBPACK FOOTER //
// ./src/axios/http.js